import React, { useContext } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { SessionContext } from "../../utility/useSession";

const RouteAuthenticated: React.FunctionComponent<RouteProps> = (props) => {
    const session = useContext(SessionContext);

    if (session.current.site != null) {
        if (session.current.site.user != null) {
            return (<Route {...props} />);
        }
    }
    return <Redirect to='/' />;

}

export default RouteAuthenticated;